/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierPlanDetail.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-plan-detail";

export class AutogenModelCarrierPlanDetail<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierPlanDetailFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierPlanDetail extends ModelRow<RowCarrierPlanDetailFields> {
	constructor(values?: Partial<RowCarrierPlanDetailFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierPlanDetailFields {
	activity_id: string;
	assigned_user_id: string;
	company_id: string;
	days: number;
	def_assign: string;
	descr: string;
	id: string;
	mark_plan_id: string;
	priority: string;
	sequence: number;
	type_of: string;
}

